import { render, staticRenderFns } from "./openbox.vue?vue&type=template&id=e3a58596&scoped=true"
import script from "./openbox.vue?vue&type=script&lang=js"
export * from "./openbox.vue?vue&type=script&lang=js"
import style0 from "./openbox.vue?vue&type=style&index=0&id=e3a58596&prod&lang=less&scoped=true"
import style1 from "./openbox.vue?vue&type=style&index=1&id=e3a58596&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3a58596",
  null
  
)

export default component.exports